import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class DataMonitoringService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    // students array format
    getREnrolledMissingSsid(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_GetREnrolledMissingSsid, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    getProvisionalSchool(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_GetProvisionalSchool, false, '', {
            chosenRegions: payload.chosenRegions,            
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    getMissingWithdrawalDate(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_GetMissingWithdrawalDate, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    getREnrollmentNotEip(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_GetREnrollmentNotEip, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,
            performancePeriod: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    getNEnrollmentNotEip(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_GetNEnrollmentNotEip, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,
            performancePeriod: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    getEIPNoEnrollment(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_GetEIPNoEnrollment, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,
            performancePeriod: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    getQadAgeEligible(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_getQadAgeEligible, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,
            performancePeriod: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    getMissingDepartureDateAndSummerIntersessionService(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_GetMissingDepartureDateAndSummerIntersessionService, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,
            performancePeriod: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    getEligibleEnrolledNotServed(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_GetEligibleEnrolledNotServed, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear,
            performancePeriod: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    // Different format
    getDuplicateREnrollmentLine(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_getDuplicateREnrollmentLine, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['DuplicateEnrollmentLines'].indexOf(property) >= 0) {
                        result['students'] = result['DuplicateEnrollmentLines'];
                        delete result['DuplicateEnrollmentLines'];

                        result['students'].forEach((student: any) => {
                            student.ENROLLMENT_DATE = new CleanDatePipe().transform(student.ENROLLMENT_DATE!);
                            student.WITHDRAWAL_DATE = new CleanDatePipe().transform(student.WITHDRAWAL_DATE!);
                            student.DEPARTURE_DATE = new CleanDatePipe().transform(student.DEPARTURE_DATE!);
                        });
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    // Service format
    getMissingServiceEndDate(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_getMissingServiceEndDate, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['missingServiceEndDates'].indexOf(property) >= 0) {
                        result['students'] = result['missingServiceEndDates'];
                        delete result['missingServiceEndDates'];

                        result['students'].forEach((student: any) => {
                            student.DOB = new CleanDatePipe().transform(student.DOB!);
                            student.StartDate = new CleanDatePipe().transform(student.StartDate!);
                            student.EndDate = new CleanDatePipe().transform(student.EndDate!);
                            student.EligibilityEndDate = new CleanDatePipe().transform(student.EligibilityEndDate!);
                        });
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }

    getDuplicateService(payload: any): Observable<any> {
        return this.post<any>(EndPoints.dataMonitoring_getDuplicateService, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['duplicateServices'].indexOf(property) >= 0) {
                        result['students'] = result['duplicateServices'];
                        delete result['duplicateServices'];

                        result['students'].forEach((student: any) => {
                            student.DOB = new CleanDatePipe().transform(student.DOB!);
                            student.EligibilityEndDate = new CleanDatePipe().transform(student.EligibilityEndDate!);
                        });
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }
}
